import React from "react"
import { PageProps } from "gatsby"
import { Layout, Seo } from "~/components"
import { Home } from '~/containers';

const IndexPage = (props: PageProps) => (
  <Layout activePage="Home" joinUs animated>
      <Seo title="Home" />
      <Home {...props}/>
  </Layout>
)

export default IndexPage
